export default "__VITE_ASSET__Ca_bOj3C__"